import request from '@/utils/request'

export function getListByMid(memberId){
    return request({
        url:'/iot/device-card/list-all?mid='+memberId,
        method:'get'
    })
}
